/* eslint-disable max-len */
import React from 'react';

const Location = props => {
	return (
		<svg
			aria-label={`location icon`}
			width={'13'}
			height={'13'}
			viewBox={'0 0 13 13'}
			fill={'none'}
			xmlns={'http://www.w3.org/2000/svg'}
			{...props}
		>
			<title>location icon</title>
			<path
				fillRule={'evenodd'}
				clipRule={'evenodd'}
				d={'M12.2666 0.444336L0.895019 4.97544L6.58081 6.26999L7.84429 12.0956L12.2666 0.444336Z'}
				fill={'#1F1F1F'}
			/>
		</svg>

	);
};

export default Location;
